import React from "react";
import { ArtistSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import SmallDetails from "components/SmallDetails/SmallDetails";
import { Section } from "components/MainSectionTemplate/types";
import { FormatArrivalTime } from "flights/lookup/FlightSearchResult";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { OptionalTextAreaDetails } from "components/ValidatedFields/OptionalTextAreaInput";
import { FlightFromAiInfo } from "./useExtractorSessionDetail";

export const extractorSessionSections = (
  state: FlightFromAiInfo,
): Array<Section> => [{
  key: "flight",
  type: "regular",
  title: "Flight from AI",
  fields: [{
    key: "artist",
    label: site.currentEnvironment.functionGroups.artist.singular,
    render: () => <ArtistSidePanel
      companyId={state.artist.artistId}
      trigger={<a>{state.artist.name}</a>}
      fallbackIfNoPermission={<>{state.artist.name}</>}
    />,
  }, {
    key: "travelAgency",
    label: RESX.Flight.TravelAgency,
    isEmpty: !state.travelAgency,
    render: () => <div>{state.travelAgency}</div>,
  }, {
    key: "notes",
    label: RESX.Note.Notes,
    isEmpty: !state.notes,
    render: () => <div>{state.notes}</div>,
  }, {
    key: "airline",
    label: RESX.Flight.Airline,
    isEmpty: !state.airline,
    render: () => <SmallDetails
      label={state.airline.name}
    />
  }, {
    key: "flightDesignator",
    label: RESX.Flight.FlightNumber,
    isEmpty: !state.flightDesignator,
    render: () => <div>{state.flightDesignator}</div>,
  }]
}, {
  key: "departureArrival",
  title: "",
  hideTitle: true,
  type: "regular",
  fields: [{
    key: "departureArrivalLabel",
    label: "",
    left: {
      key: "departureLabel",
      render: () => <h3>{RESX.Flight.Departure}</h3>
    },
    right: {
      key: "arrivalLabel",
      render: () => <h3>{RESX.Flight.Arrival}</h3>
    }
  }, {
    key: "date",
    label: RESX.DateTime.lblDate,
    left: {
      key: "departureLocal",
      render: () => <div className="flex-column">
        <div>{formatTime(state.departureLocal)}</div>
        <div>{formatWrittenDayMonthYear(state.departureLocal)}</div>
      </div>,
    },
    right: {
      key: "arrivalLocal",
      render: () => <FormatArrivalTime departure={state.departureLocal} arrival={state.arrivalLocal} />,
    }
  }, {
    key: "airport",
    label: RESX.Flight.Airport,
    left: {
      key: "departureAirport",
      render: () => <SmallDetails
        label={`${state.departureAirport.name} (${state.departureAirport.iata || state.departureAirport.icao || state.departureAirport.faa})`}
        subLabel={state.departureAirport.location}
      />,
    },
    right: {
      key: "arrivalAirport",
      render: () => <SmallDetails
        label={`${state.arrivalAirport.name} (${state.arrivalAirport.iata || state.arrivalAirport.icao || state.arrivalAirport.faa})`}
        subLabel={state.arrivalAirport.location}
      />,
    },
  }, {
    key: "terminal",
    label: RESX.Flight.Terminal,
    left: {
      key: "departureTerminal",
      isEmpty: !state.departureTerminal,
      render: () => <div>{state.departureTerminal}</div>,
    },
    right: {
      key: "arrivalTerminal",
      isEmpty: !state.arrivalTerminal,
      render: () => <div>{state.arrivalTerminal}</div>,
    }
  }, {
    key: "contact",
    label: RESX.Flight.Passenger,
    isEmpty: !state.passengerContact,
    render: () => <ContactSidePanel
      contactId={state.passengerContact.contactId}
      trigger={<a>{state.passengerContact.name.fullName}</a>}
    />,
  }, {
    key: "travelClass",
    label: RESX.Flight.TravelClass,
    isEmpty: !state.travelClass || state.travelClass.value === "unknown",
    render: () => <>{state.travelClass.text}</>,
  }, {
    key: "seat",
    isEmpty: !state.seat,
    label: RESX.Flight.Seats,
    render: () => <>{state.seat}</>,
  }, {
    key: "bookingCode",
    isEmpty: !state.bookingCode,
    label: RESX.Flight.BookingCode,
    render: () => <>{state.bookingCode}</>,
  }, {
    key: "meal",
    isEmpty: !state.meal,
    label: RESX.Flight.Meal,
    render: () => <>{state.meal}</>,
  }, {
    key: "eTicket",
    isEmpty: !state.eTicket,
    label: RESX.Flight.ETicket,
    render: () => <>{state.eTicket}</>,
  }, {
    key: "baggage",
    isEmpty: !state.baggage,
    label: RESX.Flight.Baggage,
    render: () => <OptionalTextAreaDetails>{state.baggage}</OptionalTextAreaDetails>,
  }]
}]